export enum SemaphoreKeys {
  Green = 'semaphore-green',
  Yellow = 'semaphore-yellow',
  Orange = 'semaphore-orange',
  Red = 'semaphore-red',
}
